import React from "react";
import TaskList from "@/components/TaskList";

export default function TachesPage() {
  return (
    <div className="space-y-8 max-w-4xl">
      <header>
        <div className="text-[11px] tracking-[0.2em] uppercase text-muted-foreground font-semibold">
          Rappels commercial
        </div>
        <h1 className="font-display font-black text-4xl tracking-tighter mt-1">Tâches internes</h1>
        <p className="text-sm text-muted-foreground mt-2 max-w-2xl">
          Liste centrale de tous les rappels & tâches commerciales du garage. Les tâches liées à une vente affichent un lien pour ouvrir la fiche.
        </p>
      </header>

      <TaskList title="Toutes les tâches" showVenteLink />
    </div>
  );
}
